// extracted by mini-css-extract-plugin
export default {"content":"StickyScrollX_content__BbnuL","stickyBar":"StickyScrollX_stickyBar__n2pDJ"};